export default __webpack_public_path__ + "static/media/lyor.66944c6e.webp";